import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { useTranslation } from "common/locales";

interface ConfirmCancellationDialogProps {
  dialogOpen: boolean;
  closeDialog: () => void;
  onConfirmCancel: () => void;
  onCancelCancel: () => void;
}

export default function ConfirmCancellationDialog(
  props: ConfirmCancellationDialogProps
) {
  const { onConfirmCancel, onCancelCancel, dialogOpen, closeDialog } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      open={dialogOpen}
      onClose={() => {
        onCancelCancel();
        closeDialog();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      slotProps={{
        paper: {
          sx: {
            borderRadius: "24px",
            padding: "16px",
            maxWidth: "320px",
            margin: "16px",
          },
        },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          fontSize: "1.25rem",
          fontWeight: 600,
          textAlign: "center",
          paddingBottom: "8px",
        }}
      >
        {t("confirmcanceldialog.title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{
            textAlign: "center",
            color: "#666",
            fontSize: "0.95rem",
          }}
        >
          {t("confirmcanceldialog.text")}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          padding: "16px",
          paddingTop: "8px",
          gap: "12px",
          justifyContent: "center",
        }}
      >
        <Button
          onClick={() => {
            onCancelCancel();
            closeDialog();
          }}
          sx={{
            flex: 1,
            borderRadius: "24px",
            padding: "12px 24px",
            textTransform: "capitalize",
            fontSize: "1rem",
            fontWeight: 500,
            lineHeight: 1.2,
            backgroundColor: "#E0E0E0",
            color: "#333",
            "&:hover": {
              backgroundColor: "#D0D0D0",
            },
          }}
        >
          {t("confirmcanceldialog.cancel.label")}
        </Button>
        <Button
          onClick={() => {
            onConfirmCancel();
            closeDialog();
          }}
          sx={{
            flex: 1,
            borderRadius: "24px",
            padding: "12px 24px",
            textTransform: "capitalize",
            fontSize: "1rem",
            fontWeight: 500,
            lineHeight: 1.2,
            backgroundColor: "#FFEBEE",
            color: "#D32F2F",
            "&:hover": {
              backgroundColor: "#FFCDD2",
            },
          }}
        >
          {t("confirmcanceldialog.confirm.label")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
